import 'normalize.css';
import render from './render';
import * as app from '@/app';
const { bootstrap } = app || {};
export default typeof bootstrap === 'function' ? bootstrap(render) : render();

// generated at 2026/2/5 15:15:41 by sui v3.1.128